module.exports = __webpack_public_path__ + "img/binzhou-people-government.a006b267.png";